import React from 'react'
import BGContainer from '../../Components/BGContainer'
import { Container } from '@mui/material'
import Centered from '../../Components/Centered'
import { titleStyle } from '../Main/constants'
import { EditableTypography } from '../../Components/EditableTypography'
import { RezervovatButton } from '../Main/MainPage'
import About from '../About/About'

export default function AboutPage() {
    return (
        <div>
            <BGContainer id={"fotogalerie"} sx={{ pt: '120px' }}>
                <Container maxWidth='lg' sx={{ mt: '120px' }}>
                    <BGContainer id={"omne"} sx={{
                    }}>
                        <Container maxWidth='lg' sx={{}}>
                            <Centered>
                                <EditableTypography fireKey={'about'} sx={{ mt: '0px', ...titleStyle, textAlign: 'center', mb: '120px' }} />
                            </Centered>
                            <About />
                        </Container>
                    </BGContainer>

                    <BGContainer sx={{ pb: '120px' }}>
                        <Container maxWidth='lg' sx={{ mt: '0px' }}>
                            <RezervovatButton sx={{}} />
                        </Container>
                    </BGContainer>
                </Container>
            </BGContainer>
        </div>
    )
}
